import VersionOne from './V1';
import VersionTwo from './V2';
import NotImplemented from '@jobseeker/lotus/elements/NotImplemented';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {UserProfileCardProps} from './type';

const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = VersionOne;
componentMap[VersionVariants.VERSION_TWO] = VersionTwo;
componentMap[VersionVariants.VERSION_THREE] = NotImplemented;

const UserProfileCard = (props: UserProfileCardProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default UserProfileCard;
